import React from "react";
import { useState } from "react";
import {
  Box,
  Modal,
  Button,
  Select,
  Grid,
  TableContainer,
  TableBody,
  TableRow,
  Table,
  TableHead,
  TableCell,
} from "@mui/material";
import s from "./Modal.module.css";
import { useSelector } from "react-redux";
import SearchBar from "./SearchBar/SearchBar";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
const ModalSearch = ({
  open,
  setOpen,
  toSearch,
  setProviderSelect,
  setAgencieSelect,
  setForm,
}) => {
  const { textColor } = useSelector((state) => state.local);
  const { t } = useTranslation();

  const [providersSearches, setProvidersSearches] = useState([]);
  const [agenciesSearches, setAgenciesSearches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: "1rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  const handleSetSelected = (item) => {
    if (toSearch === "proveedor") {
      setAgencieSelect({ name: t("agency") });
      setProviderSelect(item);
      setForm((prev) => ({
        ...prev,
        supplierId: item.id,
        supplierName: item.businessName,
        agencyId: null,
        agencyName: "",
      }));
      setOpen(false);
    } else if (toSearch === "agencia") {
      setProviderSelect({ businessName: t("provider") });
      setAgencieSelect(item);
      setForm((prev) => ({
        ...prev,
        agencyId: item.id,
        agencyName: `(${item.number}) ${item.name}`,
        supplierId: null,
        supplierName: "",
      }));
      setOpen(false);
    }
  };

  return (
    <>
      <Modal open={open}>
        <Grid container>
          <Grid
            container
            item
            xs={12}
            md={9}
            lg={5}
            className={s.boxModal}
            sx={{ bgcolor: "#EEEEEE" }}
          >
            <Grid
              item
              container
              xs={12}
              sx={{ justifyContent: "center", alignItem: "center" }}
            >
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 5,
                }}
              >
                <span>{`${t("find")} ${toSearch === "agencia" ? t("agency") : t("providers")}`}</span>
              </Grid>

              <Grid item xs={10}>
                <SearchBar
                  setLoading={setLoading}
                  setSearching={setSearching}
                  toSearch={toSearch}
                  setProvidersSearches={setProvidersSearches}
                  setAgenciesSearches={setAgenciesSearches}
                />
              </Grid>
              {loading ? (
                <Grid item xs={12} className={s.message}>
                  <CircularProgress size={"4rem"} />
                </Grid>
              ) : (toSearch === "proveedor" && providersSearches?.length) ||
                (toSearch === "agencia" && agenciesSearches?.length) ? (
                <>
                  <Grid
                    item
                    container
                    xs={11}
                    className={s.dataContainer}
                    sx={{ mt: 1 }}
                  >
                    <TableContainer className={s.tableContainer}>
                      <Table className={s.table}>
                        <TableHead sx={{ backgroundColor: "primary.main" }}>
                          <TableCell
                            sx={{
                              color: textColor,
                              fontSize: "18px",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                          >
                            {toSearch === "proveedor" ? "CUIT" : t("number")}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: textColor,
                              fontSize: "18px",
                              fontWeight: 500,
                              fontFamily: "Roboto, sans-Serif",
                            }}
                          >
                            {toSearch === "proveedor"
                              ? t("businessName")
                              : t("name")}
                          </TableCell>
                        </TableHead>
                        <TableBody>
                          {toSearch === "proveedor" ? (
                            <>
                              {providersSearches.map((p, i) => {
                                return (
                                  <React.Fragment key={p.cuit}>
                                    <TableRow
                                      sx={{
                                        "&:hover": {
                                          backgroundColor: "secondary.light",
                                        },
                                      }}
                                    >
                                      <TableCell
                                        sx={{
                                          ...cellStyles,
                                          backgroundColor:
                                            i % 2 === 0
                                              ? "#dbdbdb76"
                                              : "#dbdbdd12",
                                        }}
                                        onClick={() => handleSetSelected(p)}
                                      >
                                        {p.cuit}
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          ...cellStyles,
                                          backgroundColor:
                                            i % 2 === 0
                                              ? "#dbdbdb76"
                                              : "#dbdbdd12",
                                        }}
                                        onClick={() => handleSetSelected(p)}
                                      >
                                        {p.businessName}
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                );
                              })}
                            </>
                          ) : (
                            <>
                              {agenciesSearches.map((a, i) => {
                                return (
                                  <React.Fragment key={a.id}>
                                    <TableRow
                                      sx={{
                                        "&:hover": {
                                          backgroundColor: "secondary.light",
                                        },
                                      }}
                                    >
                                      <TableCell
                                        sx={{
                                          ...cellStyles,
                                          backgroundColor:
                                            i % 2 === 0
                                              ? "#dbdbdb76"
                                              : "#dbdbdd12",
                                        }}
                                        onClick={() => handleSetSelected(a)}
                                      >{`${a.number} - ${a.subNumber}`}</TableCell>
                                      <TableCell
                                        sx={{
                                          ...cellStyles,
                                          backgroundColor:
                                            i % 2 === 0
                                              ? "#dbdbdb76"
                                              : "#dbdbdd12",
                                        }}
                                        onClick={() => handleSetSelected(a)}
                                      >
                                        {a.name}
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                );
                              })}
                            </>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </>
              ) : searching ? (
                <div className={s.message}>No hay resultados</div>
              ) : (
                <div className={s.message}>Realiza un busqueda</div>
              )}
              <Grid
                item
                xs={10}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 5,
                }}
              >
                <Button
                  variant
                  onClick={() => {
                    setAgenciesSearches([]);
                    setProvidersSearches([]);
                    setSearching(false);
                    setOpen((bool) => !bool);
                  }}
                  sx={{ backgroundColor: textColor, marginTop: "10px" }}
                >
                  {t("cancel")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default ModalSearch;
